import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { FetchConsumptionProps } from '../services/consumption.service'

import { StoreError } from '~/common/model'
import {
  Consumption,
  ErrorResponseConsumption,
  ResponseConsumption,
} from '~/consumptions/model/consumption.model'

export type ConsumptionState = {
  loading: boolean
  error?: StoreError
  data?: Consumption
}

export type ConsumptionsState = {
  [key: string]: ConsumptionState
}

export const initialStateEle: ConsumptionState = {
  loading: false,
  error: undefined,
  data: undefined,
}
export const initialState = {}

export const ConsumptionSlice = createSlice({
  name: 'consumption',
  initialState: {} as ConsumptionsState,
  reducers: {
    fetchConsumption: (_state, action: PayloadAction<FetchConsumptionProps>) => {
      const {
        payload: { subscriptionId },
      } = action
      return { ..._state, [subscriptionId || '']: { ...initialStateEle, loading: true } }
    },
    fetchConsumptionSuccess(_state, action: PayloadAction<ResponseConsumption>) {
      const { payload } = action
      return {
        ..._state,
        [payload.subscriptionId]: {
          ...initialStateEle,
          data: payload.consumption,
        },
      }
    },
    fetchConsumptionError(_state, action: PayloadAction<ErrorResponseConsumption>) {
      const { payload } = action
      return { ..._state, [payload.subscriptionId]: { ...initialStateEle, error: payload.error } }
    },
  },
})

export const {
  fetchConsumption,
  fetchConsumptionSuccess,
  fetchConsumptionError,
} = ConsumptionSlice.actions

const ConsumptionReducer = ConsumptionSlice.reducer
export default ConsumptionReducer
